<template>
  <ModalDialog
    header-text="Explanation of Chometz Sale"
    contentClass="chometz-modal-content"
    @closeModal="closeModal"
    open
  >
    <template v-slot:content>
      <p>
        The Hebrew term chometz refers to certain grains (wheat, barley, spelt,
        rye and oats) which have been exposed to conditions causing some degree
        of fermentation and leavening as defined by Jewish law.
      </p>
      <p>
        According to Jewish law, a Jewish person may not consume or derive
        benefit from actual chometz, or products which contain mixtures of
        chometz, during the Passover holiday. Furthermore, a Jew is not even
        permitted to own chometz during this time-period. In addition, there is
        a penalty with respect to chometz which remained in the possession of a
        Jew during Passover. Jewish law prohibits consuming and deriving benefit
        from such products even after Passover has ended.
      </p>
      <p>
        In order to comply with this injunction against owning chometz during
        Passover, it was customary for Jews to deplete or destroy their supplies
        of chometz before Passover, or alternatively, to sell chometz to a
        non-Jew and lease the premises where the chometz is stored for the
        duration of Passover. Since the chometz belongs to a non-Jew and is
        stored in an area that is leased to a non-Jew, the chometz can remain in
        place during Passover, and the restriction of not possessing chometz is
        satisfied. The non-Jewish purchaser gives a minimal down payment and
        obligates himself to pay the full value of the chometz after Passover.
        When Passover ends, the non-Jew is approached with an offer to sell the
        chometz back to the previous owner, thus freeing the non-Jew from any
        further financial obligation.
      </p>
      <p>
        As your Kosher certifying agency, the OU has a special responsibility to
        insure the sale of your company's chometz before Passover. As mentioned
        above, if this sale would not occur, Jewish law would prohibit the
        consumption of such products which contain chometz after Passover by any
        Jewish individual. Obviously, the OU cannot allow the use of its symbol
        on products that may not be consumed, albeit the ingredients may
        otherwise meet all Kosher requirements.
      </p>
      <p>
        The sale of chometz involves many intricacies of Jewish law, and it is
        customary to authorize a competent and experienced Rabbi to execute this
        transaction. As such, we ask that you complete the linked to "Delegation
        of Power of Attorney for Sale of Chometz" which will allow Rabbi Nahum
        Rabinowitz, a member of our staff, to act as your agent to sell your
        company's chometz before Passover, and repurchase it after Passover.
      </p>
      <p>
        This sale is legally binding. Beginning on or before
        {{ startDate }} (which is when the sale is executed) until after
        Passover, {{ endDate }}. Between those dates and times you may not use
        the chometz for production, nor may you distribute products which
        contain chometz even if they were manufactured before Passover.
      </p>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";

defineProps<{
  startDate: string;
  endDate: string;
}>();

const emit = defineEmits<{
  (e: "closeModal"): void;
}>();

const closeModal = function () {
  emit("closeModal");
};
</script>

<style lang="scss">
.chometz-modal-content {
  max-width: 600px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
